import {connect} from "react-redux";
import MessagesComponent from "../components/MessagesComponent";
import {messagesSelector} from "../selectors";
import {messageByIdsSelector} from "../../_data/selectors";
import Meta from "../../_data/models/Meta";
import User from "../../_data/models/User";
import {fetchMessagesBy, sendMessage} from "../middlewares";
import {composeMessageAction} from "../actions";
import {getCurrentUser} from "../../_helpers/utils";
import {conversationByIdSelector, userByIdSelector} from "../../_data/selectors";
import * as queryString from "query-string";


const mapStateToProps = (state, props) => {
    
    const {ids, meta, loading} = messagesSelector(state);    
    const messages = messageByIdsSelector(state, ids).sort((a,b)=> a.createdAt > b.createdAt ? 1 : -1);

    let recipient:User = new User;
    let conversation = conversationByIdSelector(state, parseInt(props.match.params.id));        

    if(conversation) {

        const recipientId = getCurrentUser().id != conversation.userId1 ? conversation.userId1 : conversation.userId2;              
        recipient = userByIdSelector(state, recipientId);

    } else {
        
        const query = queryString.parse(props.location.search);
        const recipientId = query.user_id;

        const newRecipient = userByIdSelector(state, parseInt(recipientId));        
        recipient = newRecipient ? newRecipient : recipient;

        if(messages.length) {            
            conversation = conversationByIdSelector(state, messages[0].conversationId);            
        }

    }

    return {
        state: state,
        messages: messages,
        meta: meta,
        loading: loading,
        recipient: recipient,
        conversation: conversation
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        loadMore: (conversationId: number, meta: Meta) => {
            if (meta && meta.hasNext()) {
                dispatch(fetchMessagesBy(conversationId, meta.nextPage));
            }
        },
        sendMessage: () => {            
            dispatch((dispatch, getState)=>{                
                const {composedMessage} = messagesSelector(getState());    
                const query = queryString.parse(props.location.search);
                
                let recipientId:number;
                let conversationId:number;
                let isNew:boolean;

                if(query.user_id) { //new message
                    recipientId = query.user_id;
                    conversationId = null;
                    isNew = true;
                } else {
                    const conversation = conversationByIdSelector(getState(), parseInt(props.match.params.id));
                    conversationId = conversation.id;
                    recipientId = getCurrentUser().id != conversation.userId1 ? conversation.userId1 : conversation.userId2;                    
                    isNew = false;
                }
                if(composedMessage!="")
                    dispatch(sendMessage(recipientId, conversationId, composedMessage, isNew));
            });            
        }, 
        composeMessage: (message:string) => {
            dispatch(composeMessageAction(message));
        }
    };
};

const MessagesContainer = connect(mapStateToProps, mapDispatchToProps)(MessagesComponent);
export default MessagesContainer;


// WEBPACK FOOTER //
// ./app/client/message/containers/MessagesContainer.tsx